/**
 * Parses a value into a valid enum member.
 *
 * Returns:
 * - the matching enum value if valid,
 * - `defaultValue` if provided and the value is invalid,
 * - otherwise `undefined`.
 */
export function parseEnumValue<T extends Record<string, string>>(
  enumObject: T,
  value: unknown,
  defaultValue: T[keyof T] | undefined = undefined
): T[keyof T] | undefined {
  if (typeof value !== 'string') return defaultValue;

  return Object.values(enumObject).includes(value)
    ? (value as T[keyof T])
    : defaultValue;
}
